export const limitSignedNByteInteger = (int: number, bytes: number) => {
  const maxAbs = Math.pow(2, bytes)
  const intAbsMax = maxAbs / 2 - (int > 0 ? 1 : 0) //"The value of \"value\" is out of range. It must be >= -2147483648 and <= 2147483647. Received -2475280486.084"
  return Math.min(Math.abs(int), intAbsMax) * (int !== 0 ? int / Math.abs(int) : 1)
}

export const limitSignedInt16 = (int: number): number => limitSignedNByteInteger(int, 16)
export const limitSignedInt32 = (int: number): number => limitSignedNByteInteger(int, 32)
export const limitSignedInt64 = (int: number): number => limitSignedNByteInteger(int, 64)
